<template>
  <div>
    <my-head></my-head>
    <div class="nes minH">
      <h1 class="title flex-center">{{ data.title }}</h1>
      <!-- <img class="top_img" :src="data.imageUrl" alt="" /> -->
      <div v-html="data.content" style="margin-bottom: 32px"></div>

      <a :href="fj.url" v-show="fj.name" :download="fj.name" target="_blank">
        附件：{{ fj.name }}
      </a>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { getRequest } from "../../api/api";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      data: {},
      fj: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getRequest({ url: `/api/v1/bulletin/${this.$route.query.id}` }).then(
        (res) => {
          this.data = res.data;
          if (res.data.attachment) this.fj = JSON.parse(res.data.attachment)[0];
          console.log(this.fj);
        }
      );
    },
  },
};
</script>

<style lang="scss">
.nes {
  width: 80%;
  margin: 24px auto 60px;
  img {
    max-width: 100%;
  }
  .top_img {
    width: 60%;
    padding: 12px 0;
  }
  .title {
    font-size: 26px;
    font-weight: 600;
    padding: 12px 0 36px;
  }
}
</style>
